<template>
<div :class="'teammatesGrid-cell cell-' + index" @click="selectCard(index)" tabindex="0" @keydown.enter="selectCard(index)">
    <img :src="card.imageUrl" :alt="card.imageAltText" class="teammatesGrid-cell-image" />
    <div class="teammatesGrid-cell-inner">
        <h3 class="hdg hdg_4 vr_2">{{card.heading}}<template v-if="card.jobTitle">,</template><br v-if="index !== 0"/> {{card.jobTitle}}</h3>
        <div class="vr_4">{{card.location}}</div>
        <div v-if="index === 0" class="vr_4">{{card.description}}</div>
        <a v-if="index===0" :href="card.link" class="iconCta">
            <div class="iconCta-text">Read More</div>
            <div class="iconCta-icon">
                <i class="icon icon_chevron icon_chevron"></i>
            </div>
        </a>
    </div>
</div>
</template>

<script>
export default {
    props: ['card', 'index', 'selectCard', "isSlide"],
} 
</script>
